export function arrayToString<T>(
  array: T[] | null | undefined,
  getData: (value: T) => string = (x) => String(x)
) {
  return array
    ? array
        .map((value) => getData(value))
        .filter((value) => !!value)
        .join(', ')
    : '';
}
